import * as tomSelect from "/Assets/libs/TomSelect/tom-select.complete.js";
import VanillaModal from "/Assets/libs/Modal/VanillaModal.js";
import { getUrlVars } from "/Assets/js/utilities.js";

/* global dlpFillProductUrl dlpListViewUrl */

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("[data-document-listing-page]")) {
        const documentListingPage = new DocumentListingPage();
        documentListingPage.init();

        if (!documentListingPage.isMobileView()) {
            documentListingPage.openFirstCategory();
        }
    }
});

class DocumentListingPage {
    constructor() {
        this.element = null;
        this.loading = false;

        this.handleRegulatoryDocumentsClick = this.handleRegulatoryDocumentsClick.bind(this);
        this.handleIncludeDiscontinuedClick = this.handleIncludeDiscontinuedClick.bind(this);
        this.handleSearchBtnClick = this.handleSearchBtnClick.bind(this);
        this.handleSearchInputKeypress = this.handleSearchInputKeypress.bind(this);
        this.handleSearchInputClick = this.handleSearchInputClick.bind(this);
        this.handleShowAllDocumentsClick = this.handleShowAllDocumentsClick.bind(this);
    }

    init() {
        this.element = document.querySelector("[data-document-listing-page]");
        this.loading = false;
        this.bindEvents();
        this.initializeComboboxes();
        this.loadingSpinner = new VanillaModal("loadingSpinner", { transition: false });
    }

    initializeComboboxes() {
        const self = this;
        document.querySelectorAll("[data-dlp-combobox]").forEach(element => {
            let tomselect = element.tomselect;
            if (tomselect) {
                return;
            }

            new tomSelect(element, {
                maxOptions: null,
                onChange: function (value) {
                    const selectElement = document.getElementById(this.inputId);
                    self.dlpOnFilterSelectionChanged(selectElement, value);
                }
            });
        });
    }

    isMobileView() {
        return window.matchMedia("(max-width: 767px)").matches;
    }

    bindEvents() {
        document.querySelectorAll("[dlp-regulatory-documents]").forEach(element => {
            element.removeEventListener("click", this.handleRegulatoryDocumentsClick);
            element.addEventListener("click", this.handleRegulatoryDocumentsClick);
        });

        document.getElementById("chkIncludeDiscontinued").removeEventListener("click", this.handleIncludeDiscontinuedClick);
        document.getElementById("chkIncludeDiscontinued").addEventListener("click", this.handleIncludeDiscontinuedClick);

        document.querySelectorAll("[dlp-search-btn]").forEach(element => {
            element.removeEventListener("click", this.handleSearchBtnClick);
            element.addEventListener("click", this.handleSearchBtnClick);
        });

        document.querySelectorAll("[dlp-search-input]").forEach(element => {
            element.removeEventListener("keypress", this.handleSearchInputKeypress);
            element.removeEventListener("click", this.handleSearchInputClick);
            element.addEventListener("keypress", this.handleSearchInputKeypress);
            element.addEventListener("click", this.handleSearchInputClick);
        });

        document.querySelectorAll("[dlp-showall-documents]").forEach(element => {
            element.removeEventListener("click", this.handleShowAllDocumentsClick);
            element.addEventListener("click", this.handleShowAllDocumentsClick);
        });
    }

    handleRegulatoryDocumentsClick(event) {
        event.preventDefault();
        document.querySelector("[dlp-search-category]").value = "90";
        this.dlpLoadListView(false);
        this.dlpSetView("True");
    }

    handleIncludeDiscontinuedClick() {
        const includeDiscontinued = document.getElementById("chkIncludeDiscontinued").checked;
        this.dlpGetProducts(includeDiscontinued);
    }

    handleSearchBtnClick() {
        this.clearProductField();
        this.clearCategoryField();
        this.clearSubcategoryField();
        this.dlpLoadListView(false);
        this.dlpSetView("True");
    }

    handleSearchInputKeypress(event) {
        if (event.which == 13) {
            if (event.target.value != "") {
                document.querySelector("[dlp-search-btn]").click();
            }
        }
    }

    handleSearchInputClick(event) {
        event.target.select();
    }

    handleShowAllDocumentsClick(event) {
        event.preventDefault();
        const rowsContainer = event.target.closest("[dlp-result-category]");
        const documentResults = rowsContainer.querySelectorAll(".document-results");
        documentResults.forEach(element => element.classList.remove("hide", "hidden-xs"));
        rowsContainer.querySelector("[dlp-six-documents]").classList.add("hide");
        rowsContainer.querySelector("[dlp-showall-documents]").classList.add("hide");
        rowsContainer.querySelector("[dlp-all-documents]").classList.remove("hide");
    }

    dlpLoadListView(checkQs) {
        if (checkQs) {
            const qs = getUrlVars();
            const product = qs["product"] || qs["Product"];
            const search = qs["search"] || qs["Search"];
            const cat = qs["category"] || qs["Category"];
            const subcat = qs["subcategory"] || qs["Subcategory"];

            if (!product && !search && !cat && !subcat) return;
        }

        this.dlpGetDocuments();
    }

    dlpGetDocuments() {
        const self = this;
        const inputs = [
            document.querySelector("[dlp-search-input]"),
            document.querySelector("[dlp-search-product-name]"),
            document.querySelector("[dlp-search-lang]"),
            document.querySelector("[dlp-search-category]"),
            document.querySelector("[dlp-search-subcategory]")
        ];

        const selectedParams = inputs.filter(input => input && input.value && input.value.length > 0)
            .map(input => `${input.name}=${input.value}`);

        const queryString = selectedParams.join("&");
        const url = `${dlpListViewUrl}?${queryString}`;

        if (!self.loading) {
            self.loading = true;
            self.loadingSpinner.open();

            fetch(url)
                .then(response => response.text())
                .then(data => {
                    document.querySelector("[dlp-list-view]").innerHTML = data;
                    self.initializeComboboxes();
                    self.loadingSpinner.close();
                    self.loading = false;
                    self.bindEvents();
                    document.querySelectorAll(".block-foldable-content .foldable-title").forEach(element => {
                        element.addEventListener("click", () => {
                            element.closest(".block-foldable-content").classList.toggle("open");
                        });
                    });
                })
                .finally(() => {
                    history.pushState(null, null, `${window.location.pathname}?${queryString}`);
                    if (!self.isMobileView()) self.openFirstCategory();
                });
        }
    }

    openFirstCategory() {
        const firstCategory = document.querySelector(".block-foldable-content:first-child");
        if (firstCategory && firstCategory.offsetParent !== null) {
            firstCategory.classList.add("open");
        }
    }

    dlpSetView(mode) {
        if (mode === "True") {
            document.querySelector("[dlp-filter-cntnr]").classList.remove("col-md-push-3");
            document.querySelector("[dlp-filter-head]").classList.add("hide");
            document.querySelector("[dlp-default-results-msg]").classList.add("hide");
            document.querySelector("[dlp-include-discontinued]").classList.add("hide");
            document.querySelector("[dlp-regulatory-documents-cntnr]").classList.add("hide");
        } else {
            document.querySelector("[dlp-results-view]").innerHTML = "";
            document.querySelector("[dlp-filter-cntnr]").classList.add("col-md-push-3");
            document.querySelector("[dlp-filter-head]").classList.remove("hide");
            document.querySelector("[dlp-default-results-msg]").classList.remove("hide");
            document.querySelector("[dlp-include-discontinued]").classList.remove("hide");
            document.querySelector("[dlp-regulatory-documents-cntnr]").classList.remove("hide");
        }
    }

    clearSearchField() {
        document.querySelector("[dlp-search-input]").value = "";
    }

    clearProductField() {
        document.querySelector("[dlp-search-product-name]").value = "";

        const productSelect = document.querySelector("[name=dlp-search-product-name]");
        if (productSelect.tomselect) {
            productSelect.tomselect.clear(true);
        }
    }

    clearCategoryField() {
        document.querySelector("[dlp-search-category]").value = "";
    }

    clearSubcategoryField() {
        document.querySelector("[dlp-search-subcategory]").value = "";
    }

    populateInput(inputname, selectedvalue) {
        if (inputname && selectedvalue) {
            const inputElement = document.querySelector(`[${inputname}]`);
            if (inputElement) {
                inputElement.value = selectedvalue;
            }
        }
    }

    dlpOnFilterSelectionChanged(element, selectedValue) {
        const self = this;
        const inputName = element.getAttribute("name");
        self.populateInput(inputName, selectedValue);

        if (inputName === "dlp-sort-category") {
            self.sortDocuments(element, selectedValue);
        } else {
            if (inputName === "dlp-search-product-name") {
                self.clearSearchField();
                self.clearCategoryField();
                self.clearSubcategoryField();
            }
            self.dlpLoadListView(false);
            self.dlpSetView("True");
        }
    }

    dlpGetProducts(isIncludeDiscontinued) {
        fetch(`${dlpFillProductUrl}?includeDiscontinued=${isIncludeDiscontinued}`)
            .then(response => response.json())
            .then(json => {
                const select = document.querySelector("[name=dlp-search-product-name]");
                select.innerHTML = "";
                json.forEach(item => {
                    const optionElement = document.createElement("option");
                    optionElement.value = item.value;
                    optionElement.text = item.text;
                    select.add(optionElement);
                });

                const tomselect = select.tomselect;
                if (tomselect) {
                    tomselect.clearOptions();
                    tomselect.addOptions(json);
                }
            });
    }

    sortDocuments(element, value) {
        const sortContainer = element.closest("[dlp-result-category]").querySelector("[dlp-category-documents]");
        const sortItems = Array.from(sortContainer.querySelectorAll("[dlp-doc-container]"));
        const isShowAll = !element.closest("[dlp-result-category]").querySelector("[dlp-all-documents]").classList.contains("hide");

        switch (value) {
            case "mostpopular":
                sortItems.sort((a, b) => +b.dataset.numdownloads - +a.dataset.numdownloads);
                break;
            case "alphabetical":
                sortItems.sort((a, b) => a.querySelector("[dli-doc-title]").textContent.toLowerCase().localeCompare(b.querySelector("[dli-doc-title]").textContent.toLowerCase()));
                break;
            case "newest":
                sortItems.sort((a, b) => new Date(b.querySelector("[dli-doc-date]").getAttribute("dli-doc-date")) - new Date(a.querySelector("[dli-doc-date]").getAttribute("dli-doc-date")));
                break;
            case "oldest":
                sortItems.sort((a, b) => new Date(a.querySelector("[dli-doc-date]").getAttribute("dli-doc-date")) - new Date(b.querySelector("[dli-doc-date]").getAttribute("dli-doc-date")));
                break;
            default:
                break;
        }

        this.appendSortedItems(sortContainer, sortItems, isShowAll);
    }

    appendSortedItems(sortContainer, sortItems, isShowAll) {
        const itemsPerRow = 3;
        let itemCount = 0;
        let row = document.createElement("div");
        row.classList.add("row", "document-results", "flex-row");
        let rows = 1;
        const rowsToShow = this.isMobileView() ? 1 : 2;

        sortContainer.innerHTML = "";

        sortItems.forEach(item => {
            row.appendChild(item);
            itemCount++;

            if (itemCount === itemsPerRow) {
                sortContainer.appendChild(row);
                row = document.createElement("div");
                row.classList.add("row", "document-results", "flex-row");
                if (rows >= rowsToShow && !isShowAll) {
                    row.classList.add("hide");
                }
                itemCount = 0;
                rows++;
            }
        });

        if (itemCount > 0) {
            sortContainer.appendChild(row);
        }
    }
}
